import dayjs from 'dayjs';

interface SelectOptions {
    key: string;
    value: string;
    label: string;
    text: string;
    default: boolean;
}

interface GeneratedOptionsType {
    options: SelectOptions[];
    default: string;
}

/**
 * Generator of the last years to be iterated in HTMLSelectElement.
 */
export default function generateYearsOptions(
    numYears: number,
    defaultYearOffset = 0,
    yearOffset = 0
): GeneratedOptionsType {
    const getDefault = (options: SelectOptions[]) => {
        if (!defaultYearOffset) {
            return options[0].value;
        }

        const current = options.find((year) => year.default === true);

        if (current) {
            return current.value;
        }

        return options[0].value;
    };

    const options = Array.from({ length: numYears }, (_, key) => {
        const year = dayjs()
            .subtract(key + yearOffset, 'years')
            .format('YYYY');

        return {
            key: year,
            value: year,
            label: year,
            text: year,
            default: dayjs().subtract(defaultYearOffset, 'years').format('YYYY') === year,
        };
    });

    return {
        options,
        default: getDefault(options),
    };
}
